var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScanNewItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2641_1568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2151 6.56005H21.7476L16.3408 0.872314V4.67846C16.3408 5.70947 17.177 6.56005 18.2151 6.56005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3542 20.9055H6.08959C5.77245 20.9055 5.51293 20.6462 5.51293 20.3288C5.51293 20.0117 5.77245 19.7522 6.08959 19.7522H12.7363C13.1037 18.8152 13.594 18.0219 14.1997 17.229H6.08959C5.77245 17.229 5.51293 16.9697 5.51293 16.6523C5.51293 16.3352 5.77245 16.0757 6.08959 16.0757H15.2954C17.0254 14.5617 19.3178 13.5959 21.8193 13.5959C22.0571 13.5959 22.2519 13.6174 22.5403 13.6391V7.71337H18.2148C16.5425 7.71337 15.1872 6.34374 15.1872 4.67846V0H4.1289C2.70141 0 1.5625 1.16772 1.5625 2.60229V24.6037C1.5625 26.0383 2.70141 27.1772 4.1289 27.1772H12.8154C12.3181 26.0239 12.0442 24.7263 12.0442 23.3711C12.0368 22.5205 12.1523 21.6985 12.3542 20.9055ZM6.08959 12.4712H13.3923C13.7095 12.4712 13.969 12.7307 13.969 13.0481C13.969 13.3652 13.7095 13.6247 13.3923 13.6247H6.08959C5.77245 13.6247 5.51293 13.3652 5.51293 13.0481C5.51293 12.7307 5.77245 12.4712 6.08959 12.4712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8118 14.771C17.0613 14.771 13.1973 18.6348 13.1973 23.3855C13.1973 28.136 17.0613 32 21.8118 32C26.5625 32 30.4265 28.136 30.4265 23.3855C30.4265 18.6348 26.5625 14.771 21.8118 14.771ZM26.4184 23.5151C26.3103 23.6162 26.166 23.6667 26.029 23.6667C25.8777 23.6667 25.7263 23.6018 25.6108 23.4863L22.3957 20.0261V28.2585C22.3957 28.5759 22.1362 28.8354 21.8191 28.8354C21.5019 28.8354 21.2424 28.5759 21.2424 28.2585V20.019L18.0129 23.4792C17.7966 23.7099 17.4216 23.7244 17.1909 23.508C16.9604 23.2917 16.9458 22.9241 17.1621 22.6933L21.3865 18.1589C21.4946 18.0437 21.646 17.9788 21.8118 17.9788C21.9778 17.9788 22.1218 18.0437 22.2373 18.1589L26.4616 22.6933C26.6636 22.9314 26.6489 23.2991 26.4184 23.5151Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2641_1568"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanNewItem);
export default __webpack_public_path__ + "static/media/scan-new-item.8b0b307a7f08a8ccef9df4fae0f8af42.svg";
export { ForwardRef as ReactComponent };